import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { ConstantsService } from '../services/constants.service';

@Component({
  selector: 'app-gaze-support',
  templateUrl: './gaze-support.component.html',
  styleUrls: ['./gaze-support.component.scss']
})
export class GazeSupportComponent implements OnInit {
  constructor(
    public constants: ConstantsService,
    private location: Location
  ) {}

  ngOnInit(): void {}

  formatText(text: string): string {
    if (!text) return '';
    return text.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');
  }

  OnClickClose() {
    this.location.back();
  }
}
